const FAQLinks: FAQLink[][] = [
  [
    {
      linkURL:
        '/psychic-advice/love-relationship-questions/how-do-i-know-someone-is-thinking-about-me',
      linkText: 'How do I know someone is thinking about me?'
    },
    {
      linkURL: '/articles/love/ten-steps-to-survive-a-breakup',
      linkText: 'How do I get through a breakup?'
    },
    {
      linkURL:
        '/articles/psychic/how-to-set-realistic-expectations-for-a-psychic-reading',
      linkText: 'How do I get the best reading?'
    }
  ],
  [
    {
      linkURL: '/articles/psychic/how-do-i-prepare-for-a-psychic-reading',
      linkText: 'What do I need to know before my first reading?'
    },
    {
      linkURL:
        '/articles/psychic/what-are-the-most-popular-types-of-psychic-readings',
      linkText: 'What are the different types of psychic readings?'
    },
    {
      linkURL: '/deals-and-promotions',
      linkText: 'How can I start a reading for free?'
    }
  ]
];

export const FAQHeading = 'Love, Relationship, and Life FAQs';
export const FAQSubHeading = `
  You've finally decided to take the leap and talk to a psychic
  (great!), but perhaps you're still feeling a bit confused about online
  readings, whether or not they are safe, or how to choose the best Keen
  psychic to meet your needs. We're here to put your mind at ease so
  that you can get the most out of your reading - every single time.`
  .replaceAll('\n', '')
  .trim();

export default FAQLinks;
